export default __webpack_public_path__ + "static/typography-image-s-bf9736aada5c149dde151425ef55382d.png";